/**
 * Run non-critical work after paint / idle so critical-path API calls can finish first.
 */
export function scheduleDeferredWork(fn: () => void, opts?: { timeoutMs?: number }): void {
  const timeoutMs = opts?.timeoutMs ?? 1200;
  const w = window as Window & {
    requestIdleCallback?: (cb: () => void, idleOpts?: { timeout: number }) => number;
  };
  if (typeof w.requestIdleCallback === 'function') {
    w.requestIdleCallback(() => fn(), { timeout: timeoutMs });
    return;
  }
  window.setTimeout(fn, 0);
}
